import coverImageA from './images/a.webp';
import coverImageB from './images/b.webp';
import coverImageC from './images/c.webp';
import coverImageD from './images/d.webp';
import coverImageE from './images/e.webp';
import { format } from 'date-fns';
import jaLocale from 'date-fns/esm/locale/ja';

type SeminarId = string;

const coverImages = [
  coverImageA,
  coverImageB,
  coverImageC,
  coverImageD,
  coverImageE,
];

export function getCoverImageUrl(id: SeminarId): string {
  const numId = parseInt(id, 10);
  return coverImages[numId % coverImages.length];
}

/**
 * フォーマット： 9/30(木) 17:22-18:22
 */
export function stringifySchedule(startedAt: Date, endedAt: Date): string {
  const start = format(startedAt, 'M/d(E) H:mm', {
    locale: jaLocale,
  });
  const end = format(endedAt, 'H:mm');
  return `${start}-${end}`;
}
